import { useEffect, useRef } from "react";
import { toast } from "sonner";
import i18n from "@/i18n/i18n";

// Opens an item once when the page URL carries ?<param>=<id> (used by phone alert taps).
export const useOpenFromQuery = (param, items, open) => {
  const done = useRef(false);
  useEffect(() => {
    if (done.current || !items?.length) return;
    const id = new URLSearchParams(window.location.search).get(param);
    if (!id) return;
    const item = items.find((x) => x.id === id);
    done.current = true;
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    if (item) open(item);
    else toast.error(i18n.t("phoneAlerts.itemNotFound"));
  }, [param, items, open]);
};
